import { ActionTree } from "vuex";

export default <ActionTree<RootState, RootState>> {
    
}